import React, { useEffect, useState } from "react";
import "./ProfileTabs.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import AccountSetting from "./AccountSettings/AccountSetting";
import Wallet from "./Wallet/Wallet";
import Overview from "./overview/overview";
import Rented from "./rented/rented";
import Inventory from "./Inventory/Inventory";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase/firebase";

function ProfileTabs() {
  const [userisLogged, setUserisLogged] = useState();

  const navigate = useNavigate();
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid } = user;
        setUserisLogged(user);
      } else {
        setUserisLogged(user);
        navigate("/");
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <div>
      <div className="astrality-profile">
        <div className="tabs-content">
          <Tabs
            defaultActiveKey="Overview"
            id="uncontrolled-tab-example"
            className="mb-3 profile-tabs"
          >
            <Tab eventKey="Overview" title="Overview">
              <Overview />
            </Tab>
            <Tab eventKey="Inventory" title="Inventory">
              <Inventory />
            </Tab>
            <Tab eventKey="Rented" title="Assets Rented">
              <Rented />
            </Tab>
            <Tab eventKey="Wallet" title="Wallet">
              <Wallet />
            </Tab>
            <Tab eventKey="Settings" title="Account Settings">
              <AccountSetting />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
}

export default ProfileTabs;
